import { Progress } from "antd";
import { notification } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { useOutletContext } from "react-router-dom";

import { getPreAssignedUrl } from "../../../store/videogrid/api";
import ClientSideServices from "./partials/clientSideService";
var MAX_SIZE = 1048576 * 200; // 1048576 bits == 1 MB so max file upload is 500 MB
const ClientSideService = new ClientSideServices();
function ClientSideUpload(props) {
  const { setUploadUrl, storageCred, streamId, acceptFileType, setDisableEdit, uploadRef, setIsAbort } = props;
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [isMaxSizeShowMessage, setIsMaxSizeShowMessage] = useState({});
  const { entityId } = useOutletContext();
  const onUpload = async (files) => {
    try {
      setIsMaxSizeShowMessage({});
      setProgress(0);
      let type = files[0].type.split("/")[1];
      if (type !== "mp4") {
        setIsMaxSizeShowMessage({ message: "Only allows files in the MP4 format." });
        return;
      }
      if (!_.isEmpty(files) && files[0].size < MAX_SIZE) {
        setDisableEdit(true);
        setIsAbort(true);
        let file = files[0];
        let name = Math.random().toString(36).substring(2, 10);
        name = (name + file?.name?.replace(/ +/g, "")).replace(/[{()}]/g, "");

        await getPreSignedUrlFun(name, type, file);
      } else {
        setIsMaxSizeShowMessage({ message: "Please select clip less than 200 MB" });
      }
    } catch (error) {
      notification["error"]({ message: "Something went wrong" });
    }
  };

  //Function to generate a presigned url and use it to upload data.
  const getPreSignedUrlFun = async (fileName, fileType, file) => {
    setUploading(true);
    return new Promise(async (resolve, reject) => {
      try {
        let data = {
          userId: localStorage.getItem("__uid"),
          entityId: entityId,
          resourceBucket: false,
          fileName: fileName,
          contentType: fileType,
          storage_name: "",
          storageId: "",
          streamId,
        };
        let value = await getPreAssignedUrl(data);
        if (value.success) {
          return resolve(await uploadToS3(value.s3Url, value.presignedUrl, file));
        } else {
          // resetProperties();
          setIsMaxSizeShowMessage({ message: `Could you kindly re-upload the file ${file.name}?` });
          setUploading(false);
          return resolve(false);
        }
      } catch (error) {
        setUploading(false);
        return reject(error.message);
      }
    });
  };
  // This function is used to upload file using presigned upload and update the file url.
  const uploadToS3 = async (s3Url, presignedUrl, fileToUpload) => {
    return new Promise((resolve, reject) => {
      try {
        let xhr = new XMLHttpRequest();
        xhr.open("PUT", presignedUrl, true);
        xhr.setRequestHeader("Content-Type", fileToUpload.type);
        xhr.upload.addEventListener("progress", (event) => {
          if (event.lengthComputable) {
            const progressPercent = Math.round((event.loaded / event.total) * 100);
            setProgress(progressPercent);
          }
        });

        xhr.onreadystatechange = () => {
          if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
              setUploadUrl(s3Url);
              setUploading(false);
              return resolve(true);
            } else {
              // resetProperties();
              notification["error"]({
                message: `The upload of the file (${fileToUpload.name}) was unsuccessful. Please re-upload the file`,
              });
              setUploading(false);
              return resolve(false);
            }
          }
        };
        xhr.send(fileToUpload);
      } catch (error) {
        setUploading(false);
        return reject(error.message);
      }
    });
  };

  return (
    <div className="form-group">
      <Dropzone
        onDrop={(acceptedFiles) => {
          onUpload(acceptedFiles);
        }}
        accept={acceptFileType}
        disabled={uploading}
        multiple={false}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone">
            <div className="dropzone-inner" {...getRootProps()}>
              <input {...getInputProps()} multiple={false} />
              <div className="uploadClip-title">Drag file here</div>
              <div className="uploadClip-subtitle">or, if you prefer</div>
              <div className="uploadclip-inside">Choose file to add</div>
              {/* <div className="uploadClip-subtitle">size: upto 200 MB only</div> */}
              {_.isEmpty(isMaxSizeShowMessage) ? (
                <div className="uploadClip-subtitle">size: upto 200 MB only</div>
              ) : (
                <div className="uploadClip-subtitle" style={{ color: "red" }}>
                  {isMaxSizeShowMessage.message}
                </div>
              )}
              <Progress strokeLinecap="butt" type="line" percent={progress} /> {progress > 0 ? `${progress} %` : ""}
            </div>
          </div>
        )}
      </Dropzone>
    </div>
  );
}

export default ClientSideUpload;
